module.exports = __webpack_public_path__ + "static/media/bandCardDialog.f45ba62c.png";